export default __webpack_public_path__ + "static/media/bread.c223d8b1.png";